import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store/index';
import Login from '@/views/Login.vue';
import HomeView from '@/views/home/Dashboard.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      auth: false
    }
  },
  {
    path: '/map',
    name: 'map',
    meta: {
      auth: false
    },
    component: () => import(/* webpackChunkName: "applyjoin" */ '../views/map')
  },
  {
    path: '/contacts',
    name: 'marketContacts',
    component: () => import(/* webpackChunkName: "applyjoin" */ '../views/home/work/MarketContacts.vue')
  },
  {
    path: '/rent/:id',
    name: 'marketRent',
    component: () => import(/* webpackChunkName: "marketRent" */ '../views/home/pay/Rent.vue')
  },
  {
    path: '/rent/apply/:id',
    name: 'applyRent',
    component: () => import(/* webpackChunkName: "applyjoin" */ '../views/home/pay/ApplyRent.vue')
  },
  {
    path: '/deposit/:id',
    name: 'marketDeposit',
    component: () => import(/* webpackChunkName: "marketDeposit" */ '../views/home/pay/Deposit.vue')
  },
  {
    path: '/property/:id',
    name: 'marketProperty',
    component: () => import(/* webpackChunkName: "marketProperty" */ '../views/home/pay/Property.vue')
  },
  {
    path: '/bill/:id',
    name: 'bill',
    component: () => import( '../views/home/bill')
  },
  {
    path: '/applyjoin',
    name: 'applyjoin',
    component: () => import(/* webpackChunkName: "applyjoin" */ '../views/home/work/ApplyJoin.vue')
  },
  {
    path: '/applyModify/:id',
    name: 'applyModify',
    component: () => import(/* webpackChunkName: "applyjoin" */ '../views/home/work/ApplyModify.vue')
  },
  {
    path: '/recharge/:id',
    name: 'recharge',
    component: () => import(/* webpackChunkName: "applyjoin" */ '../views/home/electricity/Recharge.vue')
  },
  {
    path: '/water-recharge/:id',
    name: 'waterRecharge',
    component: () => import(/* webpackChunkName: "applyjoin" */ '../views/home/water/WaterRecharge.vue')
  },
  {
    path: '/updateUser',
    name: 'updateUser',
    component: () => import(/* webpackChunkName: "updateUser" */ '../views/user/UpdateUser.vue')
  },
  {
    path: '/notice',
    name: 'notice',
    component: () => import('../views/home/notice')
  },   
  {
    path: '/notice/detail/:id',
    name: 'noticeDetail',
    component: () => import('../views/home/notice/Detail')
  },
  {
    path: '/notice/feedback/:id',
    name: 'noticeFeedback',
    component: () => import('../views/home/notice/Feedback')
  },
  {
    path: '/repair',
    name: 'repair',
    component: () => import('../views/home/repair')
  },
  {
    path: '/unpaidBill',
    name: 'unpaidBill',
    component: () => import('../views/home/unpaidBill')
  },
  {
    path: '/unpaidBill/multiplePay/:id',
    name: 'unpaidBillMultiplePay',
    component: () => import('../views/home/unpaidBill/MultiplePay')
  },
  {
    path: '/unpaidBill/detail/:id',
    name: 'unpaidBillDetail',
    component: () => import('../views/home/unpaidBill/PayRecordList')
  },
  {
    path: '/repair/add',
    name: 'repairAdd',
    component: () => import('../views/home/repair/Edit')
  },
  {
    path: '/repair/edit/:id',
    name: 'repairEdit',
    component: () => import('../views/home/repair/Edit')
  },
  {
    path: '/repair/eva/:id',
    name: 'repairEva',
    component: () => import('../views/home/repair/Eva')
  },
  {
    path: '/repair/detail/:id',
    name: 'repairDetail',
    component: () => import('../views/home/repair/Detail')
  },
  {
    path: '/repair-feedback',
    name: 'repairFeedback',
    component: () => import('../views/home/repair/feedback')
  },
  {
    path: '/repair-feedback/repair/:id',
    name: 'repairFeedbackRepair',
    component: () => import('../views/home/repair/feedback/Repair')
  },
  {
    path: '/repair-feedback/manage/:id',
    name: 'repairFeedbackDispatch',
    component: () => import('../views/home/repair/feedback/Dispatch')
  },
  {
    path: '/propertyInspection',
    name: 'propertyInspection',
    component: () => import('../views/home/propertyInspection')
  },
  {
    path: '/propertyInspection/add',
    name: 'propertyInspectionAdd',
    component: () => import('../views/home/propertyInspection/Add')
  },
  {
    path: '/propertyInspection/edit/:id',
    name: 'propertyInspectionEdit',
    component: () => import('../views/home/propertyInspection/Add')
  },
  {
    path: '/propertyInspection/fillBaseInfo/:id',
    name: 'propertyInspectionFillBaseInfo',
    component: () => import('../views/home/propertyInspection/FillBaseInfo')
  },
  {
    path: '/propertyInspection/fillMarginInfo/:id',
    name: 'propertyInspectionFillMarginInfo',
    component: () => import('../views/home/propertyInspection/FillMarginInfo')
  },
  {
    path: '/propertyInspection/fillWaterElectric/:id',
    name: 'propertyInspectionFillWaterElectric',
    component: () => import('../views/home/propertyInspection/FillWaterElectric')
  },
  {
    path: '/propertyInspection/fillOriginalWaterElectric/:id',
    name: 'propertyInspectionFillOriginalWaterElectric',
    component: () => import('../views/home/propertyInspection/FillOriginalWaterElectric')
  },
  {
    path: '/propertyInspection/fillRentConfirmation/:id',
    name: 'propertyInspectionFillRentConfirm',
    component: () => import('../views/home/propertyInspection/FillRentConfirm')
  },
  {
    path: '/propertyInspection/fillPropertyManageConfirm/:id',
    name: 'propertyInspectionFillPropertyManageConfirm',
    component: () => import('../views/home/propertyInspection/FillPropertyManagementConfirm')
  },
  {
    path: '/propertyInspection/fillMarketingDepartmentFirstConfirm/:id',
    name: 'propertyInspectionFillMarketingDepartmentFirstConfirm',
    component: () => import('../views/home/propertyInspection/FillMarketingDepartmentFirstConfirm')
  },
  {
    path: '/propertyInspection/fillMarketingDepartmentSecondConfirm/:id',
    name: 'propertyInspectionFillMarketingDepartmentSecondConfirm',
    component: () => import('../views/home/propertyInspection/FillMarketingDepartmentSecondConfirm')
  },
  {
    path: '/propertyInspection/detail/:id',
    name: 'propertyInspectionDetail',
    component: () => import('../views/home/propertyInspection/Detail')
  },
  {
    path: '/sign-up',
    name: 'signUp',
    meta: {
      auth: false
    },
    component: () => import(/* webpackChunkName: "updateUser" */ '../views/map/SignUp.vue')
  },
  {
    path: '/canteen',
    component: () => import(/* webpackChunkName: "canteen" */ '../views/home/canteen/Layout.vue'),
    redirect: '/canteen/menu',
    children: [
      {
        path: 'menu',
        name: 'canteenMenu',
        meta: { tab: 'menu' },
        component: () => import(/* webpackChunkName: "canteen" */ '../views/home/canteen/Menu.vue')
      },
      {
        path: 'bills',
        name: 'canteenBills',
        meta: { tab: 'bills' },
        component: () => import(/* webpackChunkName: "canteen" */ '../views/home/canteen/Bills.vue')
      },
      {
        path: 'bills/pay/:id',
        name: 'canteenPay',
        meta: { tab: 'bills', hideTabbar: true, title: '账单详情' },
        component: () => import(/* webpackChunkName: "canteen" */ '../views/home/canteen/Pay.vue')
      },
      {
        path: 'recharge',
        name: 'canteenRecharge',
        meta: { tab: 'recharge' },
        component: () => import(/* webpackChunkName: "canteen" */ '../views/home/canteen/Recharge.vue')
      },
      {
        path: 'coupons',
        name: 'canteenCoupons',
        meta: { tab: 'coupons' },
        component: () => import(/* webpackChunkName: "canteen" */ '../views/home/canteen/Coupons.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {
  const hasDic = store.getters.hasDic;
  if (!hasDic) {
    await store.dispatch('getDictInfo', ["usage", "shop_type", "category_type","repair_problem"].join(","));
  }
  if (to.meta?.auth === false) {
    next();
  } else {
    const token = localStorage.getItem('token');
    if (token && token !== 'undefined') {
      const hasLogin = store.getters.hasLogin;
      if (!hasLogin) {
        return store.dispatch('getUserInfo')
          .then(next)
          .catch(() => {
            next({
              name: 'login',
              query: {
                redirect: to.fullPath
              }
            });
          });
      } else {
        next();
      }
    } else {
      next({
        name: 'login',
        query: {
          redirect: to.fullPath
        }
      });
    }
  }
})

export default router
